<template>
    <div class="home">
        <component
                :is="currentView"
                :query="normalizedQuery"
                @download="handleDownload"
                @open-app="handleOpenApp"
                @add-friend="handleAddFriend"
        />
    </div>
</template>

<script>
import HomeUserCenter from './home/pages/HomeUserCenter.vue'
import HomeStreak from './home/pages/HomeStreak.vue'
import HomeQuestion from './home/pages/HomeQuestion.vue'
import HomeDayReport from './home/pages/HomeDayReport.vue'
import HomeDayReportV2 from './home/pages/HomeDayReportV2.vue'
import HomeWeekReport from './home/pages/HomeWeekReport.vue'
import HomeLawMasterDayReport from './home/pages/lawMaster/HomeLawMasterDayReport.vue'
import HomeLawMasterWeekReport from './home/pages/lawMaster/HomeLawMasterWeekReport.vue'
import HomeLawMasterUserCenter from './home/pages/lawMaster/HomeLawMasterUserCenter.vue'
import HomeLawMasterAiShare from './home/pages/lawMaster/HomeLawMasterAiShare.vue'
import HomeLawMasterQuestion from './home/pages/lawMaster/HomeLawMasterQuestion.vue'
import HomeLawMasterFollowUp from './home/pages/lawMaster/HomeLawMasterFollowUp.vue'
import HomeLawMasterRealFollowUp from './home/pages/lawMaster/HomeLawMasterRealFollowUp.vue'
import HomeLawMasterStreak from './home/pages/lawMaster/HomeLawMasterStreak.vue'
import HomeLawExamTop10 from './home/pages/lawExam/HomeLawExamTop10.vue'
import HomeInvite from './home/pages/HomeInvite.vue'
import HomeAiShare from './home/pages/HomeAiShare.vue'
import HomeFollowUp from './home/pages/HomeFollowUp.vue'
import HomeMemoryAlgo from './home/pages/HomeMemoryAlgo.vue'

const PAGE_COMPONENTS = {
    center: HomeUserCenter,
    user: HomeUserCenter,
    profile: HomeUserCenter,
    '1': HomeUserCenter,
    streak: HomeStreak,
    flame: HomeStreak,
    '2': HomeStreak,
    question: HomeQuestion,
    qa: HomeQuestion,
    '3': HomeQuestion,
    day: HomeDayReport,
    report: HomeDayReport,
    '4': HomeDayReport,
    dayv2: HomeDayReportV2,
    'day-v2': HomeDayReportV2,
    '4v2': HomeDayReportV2,
    lawmasterday: HomeLawMasterDayReport,
    'law-master-day': HomeLawMasterDayReport,
    lawmasterdayv2: HomeLawMasterDayReport,
    'law-master-day-v2': HomeLawMasterDayReport,
    lawmasterweek: HomeLawMasterWeekReport,
    'law-master-week': HomeLawMasterWeekReport,
    lawmastercenter: HomeLawMasterUserCenter,
    'law-master-center': HomeLawMasterUserCenter,
    lawmasterai: HomeLawMasterAiShare,
    'law-master-ai': HomeLawMasterAiShare,
    lawmasterquestion: HomeLawMasterQuestion,
    'law-master-question': HomeLawMasterQuestion,
    lawmasterfollowup: HomeLawMasterFollowUp,
    'law-master-follow-up': HomeLawMasterFollowUp,
    lawmasterrealfollowup: HomeLawMasterRealFollowUp,
    'law-master-real-follow-up': HomeLawMasterRealFollowUp,
    lawmasterstreak: HomeLawMasterStreak,
    'law-master-streak': HomeLawMasterStreak,
    lawexamtop10: HomeLawExamTop10,
    'law-exam-top10': HomeLawExamTop10,
    week: HomeWeekReport,
    weekly: HomeWeekReport,
    '5': HomeWeekReport,
    invite: HomeInvite,
    '6': HomeInvite,
    ai: HomeAiShare,
    aishare: HomeAiShare,
    '7': HomeAiShare,
    followup: HomeFollowUp,
    followUp: HomeFollowUp,
    '8': HomeFollowUp,
    realfollowup: HomeFollowUp,
    realFollowUp: HomeFollowUp,
    '10': HomeFollowUp,
    memory: HomeMemoryAlgo,
    algo: HomeMemoryAlgo,
    vip: HomeMemoryAlgo,
    '618': HomeMemoryAlgo,
    '9': HomeMemoryAlgo
}

export default {
    name: 'Home',
    computed: {
        normalizedQuery () {
            const q = (this.$route && this.$route.query) || {}
            // VueRouter query 可能出现数组，这里做个规整
            const pick = (v) => (Array.isArray(v) ? v[0] : v)
            return {
                ...q,
                page: pick(q.page || q.type || q.scene || q.view || 'center')
            }
        },
        currentView () {
            const raw = String(this.normalizedQuery.page || 'center').trim().toLowerCase()
            return PAGE_COMPONENTS[raw] || HomeUserCenter
        }
    },
    methods: {
        handleDownload () {
            const url = this.normalizedQuery.downloadUrl
            if (url) {
                window.location.href = url
                return
            }
            // 你后续可按业务接入真实下载链接
            alert('TODO: 下载 app（可通过 downloadUrl 传入）')
        },
        handleOpenApp () {
            const url = this.normalizedQuery.openAppUrl
            if (url) {
                window.location.href = url
                return
            }
            // 你后续可按业务接入唤端 scheme / universal link
            alert('TODO: 打开 app（可通过 openAppUrl 传入）')
        },
        handleAddFriend () {
            // 你后续可按业务接入“加好友”逻辑
            alert('TODO: 添加好友')
        }
    }
}
</script>

<style lang="scss" scoped>
.home {
    min-height: 100vh;
}
</style>
